import { Injectable } from '@angular/core';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { JwtService } from 'src/app/services/jwt.service';
import { MsalBroadcastService } from '../msal';
import { UserAccountStoreService } from '../services/storage/user-account-store.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private readonly jwtService: JwtService,private readonly msalBroadcastService:MsalBroadcastService,
    private readonly userAccountStore: UserAccountStoreService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.jwtService.getToken();
    const substring = 'X-Amz-Credential'

    if (token && !request.urlWithParams.includes(substring)) {
       
        request = request.clone({
          setHeaders: {
            Authorization: `${token}`,
          },
        }); 
      
    }
    return next.handle(request).pipe(
      catchError((err) => { 
        const invalidToken = this.userAccountStore.tokenExpired(token)
        if (invalidToken){
          // this.userAccountStore.refreshToken()
          return this.msalBroadcastService.msalSubject$?.pipe(
            filter((msg: any) => msg.eventType === 'msal:acquireTokenSuccess'),
            switchMap((res: any) => {
            //set the payload here
            this.userAccountStore.setAccountDetails(res?.payload);
            const token2 = this.jwtService.getToken();
                return next.handle(request.clone({
                    setHeaders: {
                        Authorization: `${token2}`,
                    }
                }))
            })
          );
        }
        const error = err.error.message ?? err.statusText;
        return throwError(() => new Error(error));
      })
    );
  }
}